export default __webpack_public_path__ + "static/media/copy.5ec342d8.svg";